module.exports = __webpack_public_path__ + "img/gwgh.6c697972.png";